/**
 * PipeSizingData.js
 * Pipe sizing data for different materials
 * Contains internal diameters for standard pipe sizes
 */

// Imperial sizes (IPS - Iron Pipe Size)
// Values are internal diameters in inches
export const CopperPipeSizesImperial = [
  { displaySize: '1/2"',    id: 0.545 },  // Type K
  { displaySize: '3/4"',    id: 0.745 },
  { displaySize: '1"',      id: 0.995 },
  { displaySize: '1-1/4"',  id: 1.245 },
  { displaySize: '1-1/2"',  id: 1.481 },
  { displaySize: '2"',      id: 1.959 },
  { displaySize: '2-1/2"',  id: 2.435 },
  { displaySize: '3"',      id: 2.907 },
  { displaySize: '4"',      id: 3.857 },
  { displaySize: '5"',      id: 4.805 },
  { displaySize: '6"',      id: 5.741 },
  { displaySize: '8"',      id: 7.583 },
  { displaySize: '10"',     id: 9.449 },
  { displaySize: '12"',     id: 11.315 },  // approx Type K
  { displaySize: '14"',     id: 13.130 },
  { displaySize: '16"',     id: 15.000 },
  { displaySize: '18"',     id: 16.870 },
  { displaySize: '20"',     id: 18.750 },
  { displaySize: '22"',     id: 20.620 },
  { displaySize: '24"',     id: 22.500 },
  { displaySize: '26"',     id: 24.376 },
  { displaySize: '28"',     id: 26.250 },
  { displaySize: '30"',     id: 28.126 },
];

export const SteelPipeSizesImperial = [
  { displaySize: '1/2"',    id: 0.622 },  // Schedule 40
  { displaySize: '3/4"',    id: 0.824 },
  { displaySize: '1"',      id: 1.029 },
  { displaySize: '1-1/4"',  id: 1.360 },
  { displaySize: '1-1/2"',  id: 1.610 },
  { displaySize: '2"',      id: 2.067 },
  { displaySize: '2-1/2"',  id: 2.469 },
  { displaySize: '3"',      id: 3.068 },
  { displaySize: '4"',      id: 4.026 },
  { displaySize: '5"',      id: 5.047 },
  { displaySize: '6"',      id: 6.065 },
  { displaySize: '8"',      id: 7.981 },
  { displaySize: '10"',     id: 10.020 },
  { displaySize: '12"',     id: 11.938 },  // Schedule 40
  { displaySize: '14"',     id: 13.124 },
  { displaySize: '16"',     id: 15.000 },
  { displaySize: '18"',     id: 16.876 },
  { displaySize: '20"',     id: 18.812 },
  { displaySize: '22"',     id: 20.750 },
  { displaySize: '24"',     id: 22.624 },
  { displaySize: '26"',     id: 24.500 },
  { displaySize: '28"',     id: 26.500 },
  { displaySize: '30"',     id: 28.628 },
];

export const PEXPipeSizesImperial = [
  { displaySize: '3/8"',    id: 0.305 },  // ASTM F876
  { displaySize: '1/2"',    id: 0.430 },
  { displaySize: '5/8"',    id: 0.545 },
  { displaySize: '3/4"',    id: 0.680 },
  { displaySize: '1"',      id: 0.880 },
  { displaySize: '1-1/4"',  id: 1.055 },
  { displaySize: '1-1/2"',  id: 1.360 },
  { displaySize: '2"',      id: 1.740 },
  { displaySize: '2-1/2"',  id: 2.108 },  // SDR-7.5 approx
  { displaySize: '3"',      id: 2.567 },
  { displaySize: '4"',      id: 3.300 },
  { displaySize: '5"',      id: 4.079 },
  { displaySize: '6"',      id: 4.858 },
  { displaySize: '8"',      id: 6.325 },
  { displaySize: '10"',     id: 7.883 },
  { displaySize: '12"',     id: 9.350 },
  { displaySize: '14"',     id: 10.267 },
  { displaySize: '16"',     id: 11.733 },
  { displaySize: '18"',     id: 13.200 },
  { displaySize: '20"',     id: 14.667 },
  { displaySize: '22"',     id: 16.133 },
  { displaySize: '24"',     id: 17.600 },
  { displaySize: '26"',     id: 19.067 },
  { displaySize: '28"',     id: 20.533 },
  { displaySize: '30"',     id: 22.000 },
];

// Metric sizes
// Values are internal diameters in millimeters
export const CopperPipeSizesMetric = [
  { displaySize: '12mm',  id: 10.0 },
  { displaySize: '15mm',  id: 12.7 },
  { displaySize: '20mm',  id: 17.0 },
  { displaySize: '25mm',  id: 21.6 },
  { displaySize: '28mm',  id: 24.0 },
  { displaySize: '32mm',  id: 27.2 },
  { displaySize: '35mm',  id: 32.5 },
  { displaySize: '42mm',  id: 39.0 },
  { displaySize: '54mm',  id: 51.0 },
  { displaySize: '67mm',  id: 64.0 },
  { displaySize: '76mm',  id: 73.0 },
  { displaySize: '108mm', id: 105.0 },
  { displaySize: '133mm', id: 129.0 },
  { displaySize: '159mm', id: 155.0 },
  { displaySize: '219mm', id: 215.0 },
  { displaySize: '267mm', id: 262.0 },
  { displaySize: '305mm', id: 287.4 },
  { displaySize: '355mm', id: 333.5 },
  { displaySize: '406mm', id: 381.0 },
  { displaySize: '457mm', id: 428.5 },
  { displaySize: '508mm', id: 476.3 },
  { displaySize: '559mm', id: 523.7 },
  { displaySize: '610mm', id: 571.5 },
  { displaySize: '660mm', id: 619.0 },
  { displaySize: '711mm', id: 666.8 },
  { displaySize: '762mm', id: 714.4 },
];

export const SteelPipeSizesMetric = [
  { displaySize: '12mm',  id: 10.2 },
  { displaySize: '15mm',  id: 13.6 },
  { displaySize: '20mm',  id: 16.6 },
  { displaySize: '25mm',  id: 21.6 },
  { displaySize: '32mm',  id: 27.2 },
  { displaySize: '40mm',  id: 35.2 },
  { displaySize: '50mm',  id: 52.5 },
  { displaySize: '65mm',  id: 62.7 },
  { displaySize: '80mm',  id: 77.9 },
  { displaySize: '100mm', id: 102.3 },
  { displaySize: '125mm', id: 128.2 },
  { displaySize: '150mm', id: 154.1 },
  { displaySize: '200mm', id: 202.7 },
  { displaySize: '250mm', id: 254.5 },
  { displaySize: '305mm', id: 303.2 },
  { displaySize: '355mm', id: 333.4 },
  { displaySize: '406mm', id: 381.0 },
  { displaySize: '457mm', id: 428.6 },
  { displaySize: '508mm', id: 477.8 },
  { displaySize: '559mm', id: 527.1 },
  { displaySize: '610mm', id: 574.6 },
  { displaySize: '660mm', id: 622.3 },
  { displaySize: '711mm', id: 673.1 },
  { displaySize: '762mm', id: 727.2 },
];

export const PEXPipeSizesMetric = [
  { displaySize: '10mm',  id: 8.0 },
  { displaySize: '12mm',  id: 10.0 },
  { displaySize: '16mm',  id: 14.0 },
  { displaySize: '20mm',  id: 17.0 },
  { displaySize: '25mm',  id: 21.5 },
  { displaySize: '32mm',  id: 28.0 },
  { displaySize: '40mm',  id: 33.4 },
  { displaySize: '50mm',  id: 42.0 },
  { displaySize: '63mm',  id: 53.0 },
  { displaySize: '75mm',  id: 63.0 },
  { displaySize: '90mm',  id: 75.6 },
  { displaySize: '110mm', id: 92.4 },
  { displaySize: '125mm', id: 105.0 },
  { displaySize: '160mm', id: 134.4 },
  { displaySize: '200mm', id: 168.0 },
  { displaySize: '250mm', id: 210.0 },
  { displaySize: '315mm', id: 264.6 },
  { displaySize: '400mm', id: 336.0 },
  { displaySize: '500mm', id: 420.0 },
  { displaySize: '630mm', id: 529.2 },
  { displaySize: '750mm', id: 630.0 },
];

/**
 * Get pipe size table for a material and unit system
 */
export function getPipeSizeTable(material, isMetric) {
  const metric = isMetric || false;
  
  if (material === 'Copper') {
    return metric ? CopperPipeSizesMetric : CopperPipeSizesImperial;
  } else if (material === 'Steel') {
    return metric ? SteelPipeSizesMetric : SteelPipeSizesImperial;
  } else if (material === 'PEX') {
    return metric ? PEXPipeSizesMetric : PEXPipeSizesImperial;
  }
  
  // Default to copper if not found
  return metric ? CopperPipeSizesMetric : CopperPipeSizesImperial;
}
